export default __webpack_public_path__ + "static/media/competition4.d0fdf958.png";